<!--
 * @Descripttion: 预警管理
 * @version: 1.0
 * @Author: AI Assistant
 * @Date: 2024-01-01
 * @LastEditors: AI Assistant
 * @LastEditTime: 2024-01-01
-->
<template>
  <a-tabs class="auto-tabs">
    <a-tab-pane tab="预警管理" key="1" v-if="$hasPer(['system','student','teacher','bzr'])">
      <edu-layout type="table" :extHeight="50" topName="预警管理">
        <VeJwCjyjList slot="table"></VeJwCjyjList>
      </edu-layout>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import VeJwCjyjList from './VeJwCjyjList';

export default {
  components: {
    VeJwCjyjList
  },
  data() {
    return {
      activeName: '1',
    };
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less" scoped>
  ::v-deep .j-select-biz-component-box {
	  width: 300px;
  }	
  ::v-deep .ant-table-thead > tr > th{
  	background:#66C3FD;
  	color:#FFFFFF;
  }	
  
  ::v-deep .ant-form-item-control{
	  width: 200px !important;
  }
  
 ::v-deep .table-operator{
	 margin: 10px 0;
 }
  ::v-deep .common-layout{
	  padding:0 15px!important;
  }
  ::v-deep .ant-tabs-bar{
	  margin-bottom:0;
  }
</style> 